import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import App from './App';
import './index.css';
import { initDB } from '@/pwa/db';
import { setupAutoSync, processSyncQueue } from '@/pwa/sync';
import { registerAppSyncHandlers } from '@/pwa/syncHandlers';
import { onAuthStateChanged } from '@/services/auth.service';

// Initialize IndexedDB
initDB();

// Setup auto-sync for offline operations
registerAppSyncHandlers();
setupAutoSync();

// The load-time sync pass runs before Firebase restores the session, so
// queued photo sessions (which need an authenticated org) skip it — drain
// the queue again once auth is hydrated.
onAuthStateChanged((user) => {
  if (user && navigator.onLine) {
    processSyncQueue();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider>
      <App />
    </MantineProvider>
  </React.StrictMode>
);
